import {AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, effect, model, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MwcCheckboxControlValueAccessorDirective} from '../directives/mwc-checkbox-control-value-accessor.directive';
import {Alerts} from '../lib/alerts';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        MwcCheckboxControlValueAccessorDirective
    ],
    template: `
        <div class="layout-vbox" style="align-items: flex-start">
            <fluent-checkbox name="tiering1" ngChkboxDefaultControl [(ngModel)]="tiering1">Tiering</fluent-checkbox>
            <div>The above checkbox has currently the value {{tiering1()}}</div>
            <fluent-button (click)="tiering1.set(!tiering1())" appearance="primary">Toggle</fluent-button>

            <fluent-divider></fluent-divider>

            <fluent-switch ngChkboxDefaultControl [(ngModel)]="tiering2">Tiering</fluent-switch>
            <div>The above checbox has currently the value {{tiering2()}}</div>
            <fluent-button (click)="tiering2.set(!tiering2())">Toggle</fluent-button>

            <fluent-divider></fluent-divider>

            <div>Normal text input</div>
            <fluent-text-input ngDefaultControl tabindex="0" type="text" [(ngModel)]="text">Input Label</fluent-text-input>

            <div>Value of input: {{text()}}</div>

            <fluent-divider></fluent-divider>

            <div>Number input</div>
            <fluent-text-input ngDefaultControl tabindex="0" type="number" [(ngModel)]="floatValue" placeholder="Enter a number"></fluent-text-input>

            <div>Value of input: {{text()}}</div>
            <fluent-button (click)="onNumberDialog()">Number Dialog</fluent-button>

        </div>
    `,
    styles: `
        fluent-divider { width: 100%; margin-top: 10px; margin-bottom: 10px;}
    `
})
export class TestControlsComponent implements AfterViewInit {

    protected readonly tiering1 = signal(true);
    protected readonly tiering2 = signal(true);
    protected readonly text = model();
    protected readonly floatValue = model();

    constructor() {
        effect(() => console.log('tiering1:', this.tiering1()));
        effect(() => console.log('tiering2:', this.tiering2()));
    }

    ngAfterViewInit(): void {
        this.text.set('Initial Value');
        //this.floatValue.set(123.456);
    }

    protected async onNumberDialog() {
        const num = await Alerts.alertPromptNumeric({ body: 'Please enter a number', header: 'Number Input', initialValue: 42 });
        console.log('num:', num);
    }
}
